/* eslint-disable */
// @ts-nocheck

import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import type * as Types from '@xing-com/crate-common-graphql-types';
export type GetArticleByIdQueryVariables = Types.Exact<{
  articleID: Types.Scalars['SlugOrID']['input'];
}>;

export type GetArticleByIdQuery = {
  __typename?: 'Query';
  articlesArticle?: {
    __typename?: 'ArticlesArticle';
    slug: string;
    id: string;
    globalId: string;
    contextGlobalId: string;
    socialInteractionTargetUrn?: string | null;
    visitUrl?: string | null;
    content?: any | null;
    publishedAt?: string | null;
    publicationState: Types.ArticlePublicationState;
    header: {
      __typename?: 'ArticleHeader';
      title: { __typename?: 'ArticleTitle'; text: string };
      summary?: { __typename?: 'ArticleSummary'; text: string } | null;
      cover?:
        | {
            __typename?: 'ArticleCoverImage';
            url?: string | null;
            caption?: {
              __typename?: 'ArticleCaption';
              text?: string | null;
            } | null;
          }
        | {
            __typename?: 'ArticleCoverVideo';
            caption?: {
              __typename?: 'ArticleCaption';
              text?: string | null;
            } | null;
            video?: { __typename?: 'VideoV2'; ref?: string | null } | null;
          }
        | null;
    };
    context?:
      | {
          __typename: 'ContentInsiderPage';
          id: string;
          globalId: string;
          title: string;
          tagline?: string | null;
          description?: string | null;
          abilities: { __typename?: 'ContentPageAbilities'; canEdit: boolean };
          xingId?: {
            __typename?: 'XingId';
            id: string;
            gender?: Types.Gender | null;
            pageName: string;
            profileImage?: Array<{
              __typename?: 'ProfileImage';
              url: string;
            } | null> | null;
            userFlags?: {
              __typename?: 'UserFlags';
              displayFlag?: Types.UserFlagsDisplayFlag | null;
            } | null;
          } | null;
          insiderPageMetadata: {
            __typename?: 'ContentPageMetadata';
            followersCount: number;
            publishedArticlesCount: number;
            followersWithinContacts?: {
              __typename?: 'ContentPageFollowersWithinContactsConnection';
              total: number;
              edges: Array<{
                __typename?: 'ContentFollowerEdge';
                node: {
                  __typename?: 'ContentFollower';
                  xingId?: {
                    __typename?: 'XingId';
                    pageName: string;
                    profileImage?: Array<{
                      __typename?: 'ProfileImage';
                      url: string;
                    } | null> | null;
                  } | null;
                };
              } | null>;
            } | null;
          };
          interactions?: {
            __typename?: 'ContentPageInteractions';
            isFollowed: boolean;
          } | null;
        }
      | {
          __typename: 'ContentPage';
          id: string;
          globalId: string;
          title: string;
          tagline?: string | null;
          description?: string | null;
          url?: string | null;
          abilities: { __typename?: 'ContentPageAbilities'; canEdit: boolean };
          logoImage?: {
            __typename?: 'ContentPageLogoImage';
            square256?: string | null;
          } | null;
          entityPage?: { __typename?: 'EntityPage'; slug: string } | null;
          entityPageMetadata?:
            | {
                __typename?: 'ContentManagedPageMetadata';
                followersCount: number;
                publishedArticlesCount: number;
                followersWithinContacts?: {
                  __typename?: 'ContentPageFollowersWithinContactsConnection';
                  total: number;
                  edges: Array<{
                    __typename?: 'ContentFollowerEdge';
                    node: {
                      __typename?: 'ContentFollower';
                      xingId?: {
                        __typename?: 'XingId';
                        pageName: string;
                        profileImage?: Array<{
                          __typename?: 'ProfileImage';
                          url: string;
                        } | null> | null;
                      } | null;
                    };
                  } | null>;
                } | null;
              }
            | {
                __typename?: 'ContentPageMetadata';
                followersCount: number;
                publishedArticlesCount: number;
                followersWithinContacts?: {
                  __typename?: 'ContentPageFollowersWithinContactsConnection';
                  total: number;
                  edges: Array<{
                    __typename?: 'ContentFollowerEdge';
                    node: {
                      __typename?: 'ContentFollower';
                      xingId?: {
                        __typename?: 'XingId';
                        pageName: string;
                        profileImage?: Array<{
                          __typename?: 'ProfileImage';
                          url: string;
                        } | null> | null;
                      } | null;
                    };
                  } | null>;
                } | null;
              }
            | null;
          interactions?: {
            __typename?: 'ContentPageInteractions';
            isFollowed: boolean;
          } | null;
        }
      | null;
    settings: {
      __typename?: 'ArticleSettings';
      titleTag?: string | null;
      descriptionTag?: string | null;
      membership: Types.ArticleMembership;
    };
  } | null;
  viewer?: { __typename?: 'Viewer'; id: string } | null;
};

export type ArticleHeaderFragment = {
  __typename?: 'ArticleHeader';
  title: { __typename?: 'ArticleTitle'; text: string };
  summary?: { __typename?: 'ArticleSummary'; text: string } | null;
  cover?:
    | {
        __typename?: 'ArticleCoverImage';
        url?: string | null;
        caption?: {
          __typename?: 'ArticleCaption';
          text?: string | null;
        } | null;
      }
    | {
        __typename?: 'ArticleCoverVideo';
        caption?: {
          __typename?: 'ArticleCaption';
          text?: string | null;
        } | null;
        video?: { __typename?: 'VideoV2'; ref?: string | null } | null;
      }
    | null;
};

export type ArticleContext_ContentInsiderPage_Fragment = {
  __typename: 'ContentInsiderPage';
  id: string;
  globalId: string;
  title: string;
  tagline?: string | null;
  description?: string | null;
  abilities: { __typename?: 'ContentPageAbilities'; canEdit: boolean };
  xingId?: {
    __typename?: 'XingId';
    id: string;
    gender?: Types.Gender | null;
    pageName: string;
    profileImage?: Array<{
      __typename?: 'ProfileImage';
      url: string;
    } | null> | null;
    userFlags?: {
      __typename?: 'UserFlags';
      displayFlag?: Types.UserFlagsDisplayFlag | null;
    } | null;
  } | null;
  insiderPageMetadata: {
    __typename?: 'ContentPageMetadata';
    followersCount: number;
    publishedArticlesCount: number;
    followersWithinContacts?: {
      __typename?: 'ContentPageFollowersWithinContactsConnection';
      total: number;
      edges: Array<{
        __typename?: 'ContentFollowerEdge';
        node: {
          __typename?: 'ContentFollower';
          xingId?: {
            __typename?: 'XingId';
            pageName: string;
            profileImage?: Array<{
              __typename?: 'ProfileImage';
              url: string;
            } | null> | null;
          } | null;
        };
      } | null>;
    } | null;
  };
  interactions?: {
    __typename?: 'ContentPageInteractions';
    isFollowed: boolean;
  } | null;
};

export type ArticleContext_ContentPage_Fragment = {
  __typename: 'ContentPage';
  id: string;
  globalId: string;
  title: string;
  tagline?: string | null;
  description?: string | null;
  url?: string | null;
  abilities: { __typename?: 'ContentPageAbilities'; canEdit: boolean };
  logoImage?: {
    __typename?: 'ContentPageLogoImage';
    square256?: string | null;
  } | null;
  entityPage?: { __typename?: 'EntityPage'; slug: string } | null;
  entityPageMetadata?:
    | {
        __typename?: 'ContentManagedPageMetadata';
        followersCount: number;
        publishedArticlesCount: number;
        followersWithinContacts?: {
          __typename?: 'ContentPageFollowersWithinContactsConnection';
          total: number;
          edges: Array<{
            __typename?: 'ContentFollowerEdge';
            node: {
              __typename?: 'ContentFollower';
              xingId?: {
                __typename?: 'XingId';
                pageName: string;
                profileImage?: Array<{
                  __typename?: 'ProfileImage';
                  url: string;
                } | null> | null;
              } | null;
            };
          } | null>;
        } | null;
      }
    | {
        __typename?: 'ContentPageMetadata';
        followersCount: number;
        publishedArticlesCount: number;
        followersWithinContacts?: {
          __typename?: 'ContentPageFollowersWithinContactsConnection';
          total: number;
          edges: Array<{
            __typename?: 'ContentFollowerEdge';
            node: {
              __typename?: 'ContentFollower';
              xingId?: {
                __typename?: 'XingId';
                pageName: string;
                profileImage?: Array<{
                  __typename?: 'ProfileImage';
                  url: string;
                } | null> | null;
              } | null;
            };
          } | null>;
        } | null;
      }
    | null;
  interactions?: {
    __typename?: 'ContentPageInteractions';
    isFollowed: boolean;
  } | null;
};

export type ArticleContextFragment =
  | ArticleContext_ContentInsiderPage_Fragment
  | ArticleContext_ContentPage_Fragment;

export type ArticleAuthorFollowerFragment = {
  __typename?: 'ContentFollower';
  xingId?: {
    __typename?: 'XingId';
    pageName: string;
    profileImage?: Array<{
      __typename?: 'ProfileImage';
      url: string;
    } | null> | null;
  } | null;
};

export const ArticleHeaderFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleHeader' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticleHeader' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'title' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'summary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ArticleCoverImage' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caption' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ArticleCoverVideo' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caption' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'video' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ref' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArticleHeaderFragment, unknown>;
export const ArticleAuthorFollowerFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleAuthorFollower' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentFollower' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'xingId' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pageName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profileImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: {
                        kind: 'ListValue',
                        values: [{ kind: 'EnumValue', value: 'SQUARE_256' }],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArticleAuthorFollowerFragment, unknown>;
export const ArticleContextFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleContext' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesContextInterface' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentInsiderPage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'globalId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'abilities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'canEdit' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'xingId' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileImage' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                { kind: 'EnumValue', value: 'SQUARE_256' },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gender' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userFlags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayFlag' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'insiderPageMetadata' },
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'followersWithinContacts',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '5' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'articleAuthorFollower',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'total' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'followersCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishedArticlesCount' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tagline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'interactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isFollowed' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentPage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'globalId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'abilities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'canEdit' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tagline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'logoImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'square256' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entityPage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'entityPageMetadata' },
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'followersWithinContacts',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '5' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'articleAuthorFollower',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'total' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'followersCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishedArticlesCount' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'interactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isFollowed' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleAuthorFollower' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentFollower' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'xingId' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pageName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profileImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: {
                        kind: 'ListValue',
                        values: [{ kind: 'EnumValue', value: 'SQUARE_256' }],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<ArticleContextFragment, unknown>;
export const GetArticleByIdDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'GetArticleById' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: {
            kind: 'Variable',
            name: { kind: 'Name', value: 'articleID' },
          },
          type: {
            kind: 'NonNullType',
            type: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'SlugOrID' },
            },
          },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'articlesArticle' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'id' },
                value: {
                  kind: 'Variable',
                  name: { kind: 'Name', value: 'articleID' },
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'globalId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'contextGlobalId' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'socialInteractionTargetUrn' },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'visitUrl' } },
                { kind: 'Field', name: { kind: 'Name', value: 'content' } },
                { kind: 'Field', name: { kind: 'Name', value: 'publishedAt' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'publicationState' },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'header' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'articleHeader' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'context' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'FragmentSpread',
                        name: { kind: 'Name', value: 'articleContext' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'settings' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'titleTag' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'descriptionTag' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'membership' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'viewer' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleAuthorFollower' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ContentFollower' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'xingId' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'pageName' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'profileImage' },
                  arguments: [
                    {
                      kind: 'Argument',
                      name: { kind: 'Name', value: 'size' },
                      value: {
                        kind: 'ListValue',
                        values: [{ kind: 'EnumValue', value: 'SQUARE_256' }],
                      },
                    },
                  ],
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleHeader' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticleHeader' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'title' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'summary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'text' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'cover' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ArticleCoverImage' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caption' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'InlineFragment',
                  typeCondition: {
                    kind: 'NamedType',
                    name: { kind: 'Name', value: 'ArticleCoverVideo' },
                  },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'caption' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'text' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'video' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'ref' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'articleContext' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'ArticlesContextInterface' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentInsiderPage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'globalId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'abilities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'canEdit' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'xingId' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'profileImage' },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'size' },
                            value: {
                              kind: 'ListValue',
                              values: [
                                { kind: 'EnumValue', value: 'SQUARE_256' },
                              ],
                            },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'url' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'gender' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'pageName' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'userFlags' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'displayFlag' },
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'insiderPageMetadata' },
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'followersWithinContacts',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '5' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'articleAuthorFollower',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'total' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'followersCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishedArticlesCount' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tagline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'interactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isFollowed' },
                      },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'InlineFragment',
            typeCondition: {
              kind: 'NamedType',
              name: { kind: 'Name', value: 'ContentPage' },
            },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: '__typename' } },
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'globalId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'abilities' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'canEdit' },
                      },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'title' } },
                { kind: 'Field', name: { kind: 'Name', value: 'tagline' } },
                { kind: 'Field', name: { kind: 'Name', value: 'description' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'logoImage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'square256' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'entityPage' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'slug' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'url' } },
                {
                  kind: 'Field',
                  alias: { kind: 'Name', value: 'entityPageMetadata' },
                  name: { kind: 'Name', value: 'metadata' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: {
                          kind: 'Name',
                          value: 'followersWithinContacts',
                        },
                        arguments: [
                          {
                            kind: 'Argument',
                            name: { kind: 'Name', value: 'first' },
                            value: { kind: 'IntValue', value: '5' },
                          },
                        ],
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'edges' },
                              selectionSet: {
                                kind: 'SelectionSet',
                                selections: [
                                  {
                                    kind: 'Field',
                                    name: { kind: 'Name', value: 'node' },
                                    selectionSet: {
                                      kind: 'SelectionSet',
                                      selections: [
                                        {
                                          kind: 'FragmentSpread',
                                          name: {
                                            kind: 'Name',
                                            value: 'articleAuthorFollower',
                                          },
                                        },
                                      ],
                                    },
                                  },
                                ],
                              },
                            },
                            {
                              kind: 'Field',
                              name: { kind: 'Name', value: 'total' },
                            },
                          ],
                        },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'followersCount' },
                      },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'publishedArticlesCount' },
                      },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'interactions' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'isFollowed' },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<GetArticleByIdQuery, GetArticleByIdQueryVariables>;
